import graphqlClient from "../../../apollo";

class OrderProvider {

  orderExport(filters = []) {
    return graphqlClient.query({
      query: require("./gql/order/orderExport.graphql"),
      variables: { filters },
      fetchPolicy: "no-cache",
    });
  }

  orderFind(id) {
    return graphqlClient.query({
      query: require("./gql/order/orderFind.graphql"),
      variables: { id: id },
      fetchPolicy: "no-cache",
    });
  }

  orderFindByIdentifier(identifier) {
    return graphqlClient.query({
      query: require("./gql/order/orderFindByIdentifier.graphql"),
      variables: { identifier: identifier },
      fetchPolicy: "no-cache",
    });
  }

  findLastOrderNumber() {
    return graphqlClient.query({
      query: require("./gql/order/findLastOrderNumber.graphql"),
      fetchPolicy: "network-only",
    });
  }

  orderStateFindByIdentifier(identifier) {
    return graphqlClient.query({
      query: require("./gql/order/orderStateFindByIdentifier.graphql"),
      variables: { identifier: identifier },
      fetchPolicy: "network-only",
    });
  }

  fetchOrdersByState(state, date = null, deliveryMode = null, drinkState =  null) {
    return graphqlClient.query({
      query: require("./gql/order/orderFetchByState.graphql"),
      variables: { state, date, deliveryMode, drinkState },
      fetchPolicy: "no-cache",
    });
  }


  orderFetchByStateBetweenDates(states, dateFrom = null, dateTo = null) {
    return graphqlClient.query({
      query: require("./gql/order/orderFetchByStateBetweenDates.graphql"),
      variables: { states, dateFrom, dateTo },
      fetchPolicy: "network-only",
    });
  }

  fetchOrderGroupByState(date, deliveryModes) {
    return graphqlClient.query({
      query: require("./gql/order/orderGroupByState.graphql"),
      variables: { date: date, deliveryModes: deliveryModes },
      fetchPolicy: "no-cache",
    });
  }

  orderCashReport(date) {
    return graphqlClient.query({
      query: require("./gql/order/orderCashReport.graphql"),
      variables: { date: date },
      fetchPolicy: "network-only",
    });
  }

  orderDeliveryCost(branchId, destination, destinationPlaceId) {
    return graphqlClient.query({
      query: require("./gql/order/orderDeliveryCost.graphql"),
      variables: { branchId, destination, destinationPlaceId },
      fetchPolicy: "network-only",
    });
  }

  paginateOrder(
    pageNumber,
    itemsPerPage,
    search = null,
    filters = [],
    orderBy = null,
    orderDesc = false
  ) {
    return graphqlClient.query({
      query: require("./gql/order/orderPaginate.graphql"),
      variables: {
        pageNumber,
        itemsPerPage,
        search,
        filters,
        orderBy,
        orderDesc,
      },
      fetchPolicy: "network-only",
    });
  }

  createOrder(orderInput) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderCreate.graphql"),
      variables: { input: orderInput },
    });
  }

  updateOrderState({ id, state }) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderUpdateState.graphql"),
      variables: { id, state },
    });
  }

  updateOrderDrinkState({ id, drinkState }) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderUpdateDrinkState.graphql"),
      variables: { id, drinkState },
    });
  }

  updateOrderDeliveryUser({ orderId, userId }) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderUpdateDeliveryUser.graphql"),
      variables: { orderId, userId },
    });
  }

  updateOrderReceiptFile({ orderId, receiptFile }) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderUpdateReceiptFile.graphql"),
      variables: { orderId, receiptFile },
    });
  }

  updateOrderPaymentMethod({ orderId, paymentMethod }) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderUpdatePaymentMethod.graphql"),
      variables: { orderId, paymentMethod },
    });
  }

  updateOrderPaymentConfirm({ orderId, confirmed }) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderUpdatePaymentConfirm.graphql"),
      variables: { orderId, confirmed },
    });
  }

  updateOrder(id, orderInput) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderUpdate.graphql"),
      variables: { id, input: orderInput },
    });
  }

  deleteOrder(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/order/orderDelete.graphql"),
      variables: { id },
    });
  }
}

export default new OrderProvider();
